<div class="voices-top-section">
    <div class="app-l-container">
        <div class="app-l-page__navigation">
            <div class="app-l-page__previous" (click)="goBack()">
                <button
                    class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20">
                    <svg-icon icon="arrowLeft" class="w-100 h-100"></svg-icon>
                </button>
            </div>
            <nav class="app-l-page__breadcrumbs" aria-label="Breadcrumb">
                <ul class="breadcrumbs-list">
                    <li class="breadcrumbs-list-item">
                        <a [routerLink]="['/app/series']" translate>
                            series.title
                        </a>
                    </li>
                    <li class="breadcrumbs-list-item">
                        <a [routerLink]="['/app/series/audio']" translate>
                            series.seriesTypes.audio
                        </a>
                    </li>
                    <li
                        class="breadcrumbs-list-item app-l-current-page"
                        aria-current="page"
                        tabindex="0"
                        translate>
                        series.voiceSeries.stories
                    </li>
                </ul>
            </nav>
        </div>
        <div class="app-l-voices-banner">
            <div class="app-l-voices-banner__left">
                <h2 class="app-l-voices-banner__heading" translate>
                    series.voiceSeries.stories
                </h2>
                <!-- <h6 class="app-l-voices-banner__desc" translate>
                    Lorem ipsum dolor sit amet consectetur. Tortor sit vel.
                </h6> -->
            </div>
        </div>
    </div>
</div>

<div class="voice-series-main-container">
    <page-loader *ngIf="!loaded"></page-loader>
    <div class="series-type-section" *ngIf="loaded">
        <div class="app-l-sub-title-holder">
            <div class="app-l-subTitle">
                <!-- <span translate>series.voiceSeries.stories</span> -->
            </div>
            <div class="app-c-custom-select">
                <div
                    class="app-c-select-trigger"
                    role="combobox"
                    aria-haspopup="listbox"
                    aria-autocomplete="none"
                    aria-label="Select story category"
                    aria-controls="voice-story-category-options"
                    [attr.aria-expanded]="isOpen"
                    tabindex="0"
                    (click)="isOpen = !isOpen"
                    (keydown.enter)="isOpen = !isOpen"
                    (keydown.space)="$event.preventDefault(); isOpen = !isOpen"
                    (keydown.escape)="isOpen = false">
                    <span>
                        <ng-container *ngFor="let category of categoryList">
                            <ng-container *ngIf="categorySelected === category.ID">{{ category.Title | translate }}</ng-container>
                        </ng-container>
                    </span>
                </div>

                <ul id="voice-story-category-options" class="app-c-select-list" *ngIf="isOpen" role="listbox" aria-label="Story category options">
                    <ng-container *ngFor="let category of categoryList">
                        <li *ngIf="category.hasStories > 0" [class.is-selected]="categorySelected === category.ID"
                            role="option"
                            tabindex="0"
                            [attr.aria-selected]="categorySelected === category.ID"
                            (click)="categorySelected = category.ID; isOpen = false; getFilteredList()"
                            (keydown.enter)="categorySelected = category.ID; isOpen = false; getFilteredList()"
                            (keydown.space)="$event.preventDefault(); categorySelected = category.ID; isOpen = false; getFilteredList()">
                            {{ category.Title | translate }}
                        </li>
                    </ng-container>
                </ul>
                </div>
            </div>
        <div class="series-type-list">
            <ng-container *ngFor="let story of filteredStoryList">
                <article
                    tabindex="0"
                    role="button"
                    [attr.aria-label]="
                        story['title_' + lang] +
                        ' by ' +
                        story['author_' + lang]
                    "
                    class="series-type-card type-allen"
                    (keydown.enter)="goToVoiceStory(story)"
                    (keydown.space)="goToVoiceStory(story)"
                    (click)="goToVoiceStory(story)">
                    <div class="cover-image-section">
                        <img
                            [defaultImage]="
                                '../../../assets/img/series/voice-stories-bg.svg'
                            "
                            [lazyLoad]="story.imageUrl"
                            alt="{{ story['title_' + lang] }} cover image" />
                    </div>
                    <div class="card-content">
                        <span class="card-title">{{
                            story ? story['title_' + lang] : ''
                        }}</span>
                        <span class="card-author">{{
                            story ? story['author_' + lang] : ''
                        }}</span>
                    </div>
                </article>
            </ng-container>
        </div>
        <ng-container *ngIf="filteredStoryList.length == 0">
            <div class="empty-card">
                <div class="app-dm-positive-cards" translate>series.noData</div>
            </div>
        </ng-container>
    </div>
</div>
